const { env } = require('components/Helpers')

// Impersonation for the new my page (../mypage-ui-next).
//
// This talks to memberships directly rather than through admin-api, the way
// MembershipsV2 already does: only memberships can mint a token the new app's
// API accepts. Its member verifiers pin iss:memberships, and admin-api's
// /memberships/authenticate — what the legacy "View my page" button uses —
// mints iss:admin-api, which they reject.
//
// It also cannot use ./api, which is why the fetch is hand-rolled: those
// helpers send the stored token raw as `Authorization`, because admin-api hands
// the whole header to jwt.verify. memberships instead reads the SECOND word of
// the header (Base::HTTP::Admin), so without the Bearer prefix every call is a
// 401 before it ever reaches the route.
// The default reporter logs rather than swallowing: with no handler a refusal
// looks to the tester like the button simply does nothing.
const logFailure = (body, status) =>
  console.error('impersonate failed', status || '', body)

const impersonate = (membershipId, success, error = logFailure) => {
  const url = `https://memberships.${env()}.credlock.net/api/memberships/${membershipId}/impersonate`

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${window.localStorage.getItem('auth-token') || ''}`
    }
  })
    .then((response) => {
      if (!response.ok) {
        return response.text().then((body) => error(body, response.status))
      }
      return response.json().then(success)
    })
    .catch((err) => error(err))
}

module.exports = {
  impersonate
}
